import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import AuthSubHeader from 'src/components/authSubHeader';
import FooterText from 'src/components/footerText';

import useFetch from 'src/hooks/useFetch';

import { APIEndpoints } from 'src/types/apiTypes';
import { PrecertAPIResponse } from '../precert/types';




const ReviewMedPA: React.FC = () => {
  const [note, setNote] = useState<string>("Input Changes Requested Here");

  const { caseId, precertId } = useParams();
  const location = useLocation();
  const queryParam = new URLSearchParams(location.search); // Parse query params
  const navigate = useNavigate();

  // const [title] = useState((location.state as { title: string }).title)
  // const [patient,setPatient] = useState((location.state as { patient: string }).patient)


  const updateNote = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setNote(event.target.value);
  };
  const { data: reviewFile } =
    useFetch<{ precert_file: string }>(APIEndpoints.GET_PRECERT_REVIEW_FILE, {}, { caseId, precertId: precertId, button_type:"review PA" })


  // const { mutate: updatePriorMutate, data: updatePriorResponse } =
  //   useFetch<PrecertAPIResponse>(APIEndpoints.UPDATE_PRIOR_AUTH, {}, {}, false);

  // useEffect(() => {
  //   if (fetchPrecertResponse) {
  //     navigate(`/cases`);
  //   }

  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [updatePriorResponse]);

  // const navigateToUpdatePrior = () => {
  //   const pathParams = {
  //     case_id: caseId,
  //     id: precertsId
  //   }
  //   const queryParams = {
  //     prior_authorization_approval: false,
  //     status: 14,
  //     case_id: caseId,
  //   }
  //   // setPrecertPathParameters(pathParams)
  //   updatePriorMutate({}, pathParams, queryParams)
  // }
  // const handleRequestChange = () => {
  //   const confirmDeny = window.confirm("Are you sure you wish to deny this precert request?");
  //   if (confirmDeny) {
  //     // Handle the logic to deny precert here
  //     if (title.includes("Med PA")){
  //       navigateToUpdatePrecert()

  //     }else{
  //       navigateToUpdatePrior()
  //     }

  //     console.log("Request denied with note:", note);
  //   }
  // };



  const { mutate: fetchPrecertMutate, data: fetchPrecertResponse } =
    useFetch<PrecertAPIResponse>(APIEndpoints.UPDATE_PRECERT, {}, {}, false);

  useEffect(() => {
    if (fetchPrecertResponse) {
      navigate(`/cases`);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchPrecertResponse]);



  const navigateToUpdatePrecert = () => {
    const pathParams = {
      case_id: caseId,
      id: precertId
    }
    const queryParams = {
      precert_approval: false,
      status: "pending_transcription",
      case_id: caseId,
      change_note:note
    }
    // setPrecertPathParameters(pathParams)
    fetchPrecertMutate({}, pathParams, queryParams)
  }
  const handleRequestChanges = () => {
    const confirmDeny = window.confirm("Are you sure you wish to deny this precert request?");
    if (confirmDeny) {
      // Handle the logic to deny precert here
      // const title = queryParam.get('title');
      // if (title && title.includes("Med PA")) {
        navigateToUpdatePrecert()
      //} 

      console.log("Request denied with note:", note);
    }
  };
  const handleApproveAndSubmitToInsuranceChanges = () => {
    const confirmDeny = window.confirm("Are you sure wish to send this precert to the insurance company? This cannot be undone!");
    if (confirmDeny) {
      const pathParams = {
        case_id: caseId,
        id: precertId
      }
      const queryParams = {
        precert_approval: false,
        status: "submitted",
        case_id: caseId,
        change_note:note
      }
      // setPrecertPathParameters(pathParams)
      fetchPrecertMutate({}, pathParams, queryParams)

      console.log("Request denied with note:", note);
    }
  };

  return (
    <div className="cases-page body-bg overflow-y-auto overflow-x-hidden d-flex flex-column flex-fill">
      <div className="container px-4 pt-2">
        <AuthSubHeader />

        <div className="card p-0">
          <h1 className="card-header">{queryParam.get('title')}</h1>
          <div className="card-header">
              <h4 className="mb-0">Insurance Name: {queryParam.get('insuranceName')}</h4>
            </div>
          <div className="card-body">
            <p>
              Review the below information and select "Approve" to have the form sent to the insurance company.
              Alternatively, input any requested changes or updates in the notes field and click "Request Changes"
              below.
            </p>

            <div className="iframe-container">
              {reviewFile && reviewFile.precert_file && reviewFile.precert_file.length > 0 ? (
                  <iframe
                    title="Precert PDF"
                    src={`data:application/pdf;base64,${reviewFile.precert_file}#zoom=90`}
                    style={{ width: "100%", height: "70vh" }}
                  />
                ) : (
                  <div>
                    <h2 className="text-center" style={{color: '#808285'}}>Form not uploaded, please contact support.</h2>
                  </div>
              )}
            </div>

            <div className="row my-2">
              <label htmlFor="note" className="form-label col-md-2 col-12">
                Notes
              </label>

              <div className="col-md-10 col-12">
                <textarea
                  name="note" id="note" className="form-control"
                  value={note} onChange={updateNote}
                  style={{ resize: "none" }} rows={4}
                ></textarea>
              </div>
            </div>

            <div className='row my-2'>
              <div className='d-flex justify-content-end flex-wrap gap-1'>
                <button
                  className="btn btn-danger btn-lg mt-2 "
                  onClick={handleRequestChanges}
                >
                  Request Changes
                </button>

                {reviewFile && reviewFile.precert_file && reviewFile.precert_file.length > 0 &&
                  <button
                    className="btn btn-success btn-lg mt-2 "
                    onClick={handleApproveAndSubmitToInsuranceChanges}
                  >
                    Approve and Submit to Insurance
                  </button>
                }
              </div>
            </div>
            
          </div>
        </div>

        <div className="mt-3"><FooterText footerType="black" /></div>
      </div>
    </div>
  );
};

export default ReviewMedPA;
